/**
 * Zeniora Blog Article Table of Contents (TOC)
 * Automatically scans <h2> headings and generates a mobile-first foldable TOC.
 */
(function () {
  'use strict';

  function initZenioraTOC() {
    const configEl = document.querySelector('[data-zeniora-toc-config]');
    if (!configEl) return;

    // Avoid double initialization
    if (document.querySelector('.zeniora-toc')) return;

    const enabled = configEl.getAttribute('data-enabled') === 'true';
    if (!enabled) return;

    const titleText = configEl.getAttribute('data-title') || 'Table of Contents';
    const defaultOpen = configEl.getAttribute('data-default-open') === 'true';
    const minHeadings = parseInt(configEl.getAttribute('data-min-headings') || '3', 10);

    // Find article content container
    const contentEl = document.querySelector('.m-article__content') || document.querySelector('.m-article .rte');
    if (!contentEl) return;

    // Collect all h2 elements inside content
    const headings = Array.from(contentEl.querySelectorAll('h2')).filter(function (h2) {
      return !h2.closest('.zeniora-toc') && !h2.hasAttribute('data-toc-ignore') && h2.textContent.trim().length > 0;
    });

    if (headings.length < minHeadings) {
      return;
    }

    // Build TOC container
    const toc = document.createElement('nav');
    toc.className = 'zeniora-toc';
    toc.setAttribute('aria-label', titleText);
    toc.setAttribute('data-state', defaultOpen ? 'open' : 'closed');

    // Header / Toggle button
    const headerBtn = document.createElement('button');
    headerBtn.type = 'button';
    headerBtn.className = 'zeniora-toc__header';
    headerBtn.setAttribute('aria-expanded', defaultOpen ? 'true' : 'false');
    headerBtn.innerHTML = `
      <div class="zeniora-toc__title-wrap">
        <span class="zeniora-toc__icon" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="8" y1="6" x2="21" y2="6"></line>
            <line x1="8" y1="12" x2="21" y2="12"></line>
            <line x1="8" y1="18" x2="21" y2="18"></line>
            <line x1="3" y1="6" x2="3.01" y2="6"></line>
            <line x1="3" y1="12" x2="3.01" y2="12"></line>
            <line x1="3" y1="18" x2="3.01" y2="18"></line>
          </svg>
        </span>
        <span class="zeniora-toc__title">${escapeHTML(titleText)}</span>
      </div>
      <span class="zeniora-toc__toggle" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </span>
    `;

    // Body & List
    const body = document.createElement('div');
    body.className = 'zeniora-toc__body';

    const inner = document.createElement('div');
    inner.className = 'zeniora-toc__inner';

    const list = document.createElement('ul');
    list.className = 'zeniora-toc__list';

    // Generate items & assign anchor IDs
    const usedIds = new Set();

    headings.forEach(function (heading, index) {
      let anchorId = heading.id;
      if (!anchorId) {
        // Generate slug from heading text or fallback to index
        const text = heading.textContent.trim();
        let slug = text
          .toLowerCase()
          .replace(/[^\w\u4e00-\u9fa5\s-]/g, '')
          .replace(/\s+/g, '-')
          .slice(0, 50);

        if (!slug || usedIds.has(slug)) {
          slug = 'section-' + (index + 1);
        }

        anchorId = slug;
        heading.id = anchorId;
      }
      usedIds.add(anchorId);

      const li = document.createElement('li');
      li.className = 'zeniora-toc__item';

      const numStr = (index + 1) + '.';

      const link = document.createElement('a');
      link.className = 'zeniora-toc__link';
      link.href = '#' + anchorId;
      link.innerHTML = `
        <span class="zeniora-toc__num">${numStr}</span>
        <span class="zeniora-toc__text">${escapeHTML(heading.textContent.trim())}</span>
      `;

      // Smooth scroll on click
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.getElementById(anchorId);
        if (target) {
          const headerOffset = getHeaderOffset();
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          if (history.pushState) {
            history.pushState(null, '', '#' + anchorId);
          }
        }
      });

      li.appendChild(link);
      list.appendChild(li);
    });

    inner.appendChild(list);
    body.appendChild(inner);
    toc.appendChild(headerBtn);
    toc.appendChild(body);

    // Toggle event
    headerBtn.addEventListener('click', function () {
      const currentState = toc.getAttribute('data-state');
      const newState = currentState === 'open' ? 'closed' : 'open';
      toc.setAttribute('data-state', newState);
      headerBtn.setAttribute('aria-expanded', newState === 'open' ? 'true' : 'false');
    });

    // Insert TOC before the first <h2>
    headings[0].before(toc);
  }

  function getHeaderOffset() {
    let offset = 20; // base padding
    const stickyHeader = document.querySelector('.m-header--sticky, header.sticky, .m-header-section, #shopify-section-header');
    if (stickyHeader) {
      offset += stickyHeader.offsetHeight || 0;
    }
    return offset;
  }

  function escapeHTML(str) {
    return str.replace(/[&<>'"]/g, function (tag) {
      return ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[tag] || tag);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZenioraTOC);
  } else {
    initZenioraTOC();
  }

  // Support Shopify theme editor reload
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.m-article')) {
      initZenioraTOC();
    }
  });
})();
